import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from 'components/common/MaterialIcon';
import {Input, Select, Row, Col, Button} from 'antd';
import uuidv1 from 'uuid/v1';

@autobind
/**
 *
 */
export default class Action extends React.PureComponent {
  static propTypes = {
    templates: PropTypes.array,
    template: PropTypes.string,
    onLoad: PropTypes.func,
    onDelete: PropTypes.func,
    onSave: PropTypes.func,
  };
  static defaultProps = {
    templates: [],
    template: 'new',
    onLoad: () => {
    },
    onDelete: () => {
    },
    onSave: () => {
    },
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      template: props.template,
    };
  }

  /**
   *
   */
  componentDidMount() {
  }

  _renderList(templates) {
    let items = [];
    if (!app._.isEmpty(templates)) {
      templates.map((item) => {
        items.push(<Select.Option key={item.key} value={item.key}>{item.title}</Select.Option>);
      });
    }

    return items;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {templates, onLoad, onSave, onDelete} = this.props;
    const {template} = this.state;

    let style = {
      margin: 2,
    };
    return (

      <Row>
        <Col
          sm={24}
        >
          <Input.Group compact style={style}>
            <Select
              size={'small'}
              style={{width: 300}}
              value={template}
              optionFilterProp="children"
              onChange={(template) => this.setState({template})}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              <Select.Option value="new">New Template</Select.Option>
              {this._renderList(templates)}
            </Select>
            <Button
              style={{height: 22}}
              key="delete"
              type='danger'
              disabled={template === 'new' || template === ''}
              size="large"
              onClick={() => onDelete(template)}>
              {app.translate('main.Delete')}
            </Button>
            <Button
              style={{height: 22}}
              key="load"
              disabled={template === 'new' || template === ''}
              size="large"
              onClick={() => onLoad(template)}>
              {app.translate('main.Load')}
            </Button>
            <Button
              type='primary'
              style={{height: 22}}
              key="save"
              size={'small'}
              onClick={() => onSave(template)}>
              {app.translate('main.Save')}
            </Button>
          </Input.Group>
        </Col>

      </Row>
    );
  }
}
